/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_AttendeesInputs */

const cs_tasks_protocol_attendees = /** @type {(inputs: Tasks_Protocol_AttendeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účastníci prohlídky`)
};

const en_tasks_protocol_attendees = /** @type {(inputs: Tasks_Protocol_AttendeesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attendees`)
};

/**
* | output |
* | --- |
* | "Attendees" |
*
* @param {Tasks_Protocol_AttendeesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_attendees = /** @type {((inputs?: Tasks_Protocol_AttendeesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_AttendeesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_attendees(inputs)
	return cs_tasks_protocol_attendees(inputs)
});